import React, { useState } from 'react';
import { Container, Row, Col, Tabs, Tab, Table } from 'react-bootstrap';
import principleImage from '../Image/principal_new.png';
import './Pdesk.css';

const AboutUs = () => {
  const [key, setKey] = useState('message');

  return (
    <div className="pdesk-container">
      <Container>
        {/* Header Section */}
        <div className="pdesk-header">
          <img src={principleImage} alt="Dr. Satya Upadhyaya" className="pdesk-image" />
          <div className="pdesk-info">
            <h1>Dr. Satya Upadhyaya</h1>
            <h4>Principal / Secretary</h4>
            <ul className="pdesk-contact">
              <li>📞 9433936302</li>
              <li>✉️ satyatiwari63@gmail.com</li>
              <li>📍 152, Swamiji Sarani Basak Bagan, Kolkata-700048</li>
            </ul>
          </div>
        </div>

        {/* Tabs Section */}
        <div className="pdesk-tabs">
          <Tabs
            id="pdesk-profile-tabs"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="mb-3"
          >
            <Tab eventKey="message" title="Principal's Message">
              <div className="pdesk-tab-content text-start">
                <div className="pdesk-message-card">
                  <p>
                    Dear Students, Parents, Guardians and all our esteemed stakeholders,
                  </p>
                  <p>
                    Calcutta Girls’ College is an institution where students are being nurtured, through its 
                    journey of more than five decades, with liberal learning, scientific approach, environmental awareness, social 
                    consciousness and women’s dignity and rights. We ensure a healthy ambience for the pursuit of higher education through 
                    Grievance Redressal Cell, Internal Complaints Committee 
                    and Anti-Ragging Cell. We keep them informed about all notifications through sms alerts.
                  </p>
                  <p>
                    As the Principal of an institution accredited by the NAAC in the 2nd cycle with B, I am happy to 
                    state that we are engaged in a continuous review and upgradation of our academic and infrastructural 
                    support to our students who are pursuing B.A., B.Com and B.Sc courses and P.G. courses under DODL, 
                    Vidyasagar University. The college offers Virtual Class Room and Smart Class Room facilities, 
                    a considerably rich library with e-facilities, a healthy Canteen. Students are initiated into 
                    various aspects of higher education through Deeksharambh. The college has an active NSS unit and 
                    encourages several cocurricular activities. While Bharosa, our Women’s Cell organizes various 
                    programmes on gender sensitization, Sahara is a unique attempt on our part to showcase the arts 
                    and handicrafts of our students and offer sustained support towards training, upgradation and 
                    marketing of the products. We also organize regular programmes for providing platform for job 
                    interface through Career Counselling. I am certain that your association with Calcutta Girls’ 
                    College will grow into an enriching bonding lasting a lifetime. I look forward to your views
                    and suggestions in our journey towards excellence.
                  </p>
                  <div className="pdesk-signature">
                    Dr. Satya Upadhyaya<br />
                    Principal
                  </div>
                </div>
              </div>
            </Tab>

            <Tab eventKey="academic" title="Academic Profile">
              <div className="pdesk-tab-content text-start">
                <h3 className="pdesk-section-title">Academic Qualifications</h3>
                <Table responsive striped hover className="pdesk-table">
                  <thead>
                    <tr>
                      <th>Examination</th>
                      <th>Board/Council</th>
                      <th>% of Marks</th>
                      <th>Subject / Details</th>
                      <th>Division/Class</th>
                      <th>Year</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Madhyamik</td>
                      <td>WBBSE</td>
                      <td>56.1%</td>
                      <td>Hindi, English, Sanskrit, Maths, Physics, Life Sc, History, Geography, Work Ed</td>
                      <td>2nd</td>
                      <td>1978</td>
                    </tr>
                    <tr>
                      <td>Higher Secondary</td>
                      <td>WBCHS</td>
                      <td>62%</td>
                      <td>Hindi, English, Psy, Phil, Edu</td>
                      <td>1st</td>
                      <td>1980</td>
                    </tr>
                    <tr>
                      <td>B.A (Hons)</td>
                      <td>University of Calcutta</td>
                      <td>60.1%</td>
                      <td>Hindi</td>
                      <td>1st</td>
                      <td>1983</td>
                    </tr>
                    <tr>
                      <td>M.A</td>
                      <td>University of Calcutta</td>
                      <td>61%</td>
                      <td>Hindi</td>
                      <td>1st Class First (Gold Medal)</td>
                      <td>1985</td>
                    </tr>
                    <tr>
                      <td>NET</td>
                      <td>UGC/Joint CSIR</td>
                      <td>JRF & SRF</td>
                      <td>Hindi</td>
                      <td>Qualified</td>
                      <td>1990</td>
                    </tr>
                    <tr>
                      <td>Ph.D</td>
                      <td>University of Calcutta</td>
                      <td>-</td>
                      <td>Hindi</td>
                      <td>Awarded</td>
                      <td>1997</td>
                    </tr>
                    <tr>
                      <td>NCC</td>
                      <td>Pre Commission Certificate</td>
                      <td>72.3%</td>
                      <td>-</td>
                      <td>All India Topper (Gold Medal)</td>
                      <td>2002</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Tab>

            <Tab eventKey="experience" title="Experience & Guidance">
              <div className="pdesk-tab-content">
                <Row>
                  <Col md={12}>
                    <h3 className="pdesk-section-title">Teaching Experience</h3>
                    <Table responsive hover className="pdesk-table mb-4">
                      <thead>
                        <tr>
                          <th>Position Held</th>
                          <th>Institution</th>
                          <th>Duration</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Guest Lecturer</td>
                          <td>Jalan Girls College</td>
                          <td>Dec 1987 - Oct 1989</td>
                        </tr>
                        <tr>
                          <td>JRF Fellow</td>
                          <td>University of Calcutta</td>
                          <td>Jul 1990 - Dec 1993</td>
                        </tr>
                        <tr>
                          <td>Lecturer to Associate Professor</td>
                          <td>Vidyasagar College for Women</td>
                          <td>Jan 1994 - Dec 2016</td>
                        </tr>
                        <tr>
                          <td>Principal / Secretary</td>
                          <td>Calcutta Girls’ College</td>
                          <td>Dec 2016 - Till Date</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  
                  <Col md={12}>
                    <h3 className="pdesk-section-title mt-4">Research Guidance (Enrolled in Univ. of Calcutta)</h3>
                    <ol className="pdesk-list text-start">
                      <li>Two M.Phil</li>
                      <li>Two Ph.D. Awarded (1. Dr. Bikram Kumar Shaw, 2. Dr. Rekha Tripathi)</li>
                      <li>Two Ph.D. Ongoing</li>
                    </ol>
                  </Col>
                </Row>
              </div>
            </Tab>

            <Tab eventKey="publications" title="Publications">
              <div className="pdesk-tab-content text-start">
                <h3 className="pdesk-section-title">Books / Book Chapters</h3>
                <ol className="pdesk-list">
                  <li><strong>Hindi Patrakarita Hamari Virasat Khand -I</strong> (Chapter) - Varni Prakasan, 1993</li>
                  <li><strong>Adhunik Sahitya Mulayakan Ke Naye Pariprekshy</strong> (Chapter) - UGC Academic Staff College, 2001</li>
                  <li><strong>Vishnu Kant Shastri Amrit Mahotsav Abhinandan Granth</strong> (Chapter) - Bada Bazar Kumar Sabha Pushtakalay, 2004</li>
                  <li><strong>Varan Parichay</strong> (Sole Translation, Bengali to Hindi) - Kendriye Sachiwale Hindi Parishad, 2008</li>
                  <li><strong>Hindi Vvykran Aur Rachna</strong> (Co-Author) - Nalanda Sahitya Sadan, 2008</li>
                  <li><strong>Apne Apne Agyen</strong> (Chapter) - Manav Prakasan, 2013</li>
                  <li><strong>Sita Vanvas</strong> (Sole Translation, Bengali to Hindi) - Anand Prakasan, 2014</li>
                  <li><strong>Dinkar Ki Kavya Sadhna</strong> (Sole) - Bharat Vidya International, 2014</li>
                  <li><strong>Dinkar Ki Sahitivik Manyataye</strong> (Sole) - Manav Prakasan, 2015</li>
                  <li><strong>Awadhi Lok Geeton Ka Samaj Shastriya Addyayan</strong> (Sole) - 2015</li>
                  <li><strong>Dr. Nirmal Walia Abhinandan Granth</strong> (Chapter) - Kitabh Ghar Nayi Dilli, 2019</li>
                  <li><strong>Dr. Nirmal Walia Ka Upanyasik Sansaar</strong> (Chapter) - Roli Book Distributers Kanpur, 2022</li>
                  <li><strong>Samuchchay</strong> (Co-Author) - Ananad Prakasan, 2024</li>
                  <li><strong>Hindi Patrikarita Me Bhasa, Sahitya Aur Sankriti</strong> (Co-Editor) - Bharat Vidya International, 2026</li>
                  <li><strong>Bharteey Bauddhik Paramparaon Ki Samkalin Prasangikata</strong> (Chapter) - Veer Narmad Gujrat University, 2026</li>
                </ol>
                
                <h3 className="pdesk-section-title mt-4">Selected Articles</h3>
                <ol className="pdesk-list">
                  <li>Jhuta Sach Aur Tamas Ka Yatharth - Sankalp (Univ. of Calcutta)</li>
                  <li>Mahadevi Verma Ke Sahitya Me Arya Samaji Chetna - Arya Sansar (Kolkata), Oct 2000</li>
                  <li>Urvasi Ka Pariprekshy - Sankalp-7 (Univ. of Calcutta)</li>
                  <li>Mahadevi Ke Samsaran - Ahinsa</li>
                  <li>Hum Bhali Bhati Agh Ko Pahchan Gaye Hain - Karwa</li>
                  <li>Yeitihasik Prishthbhumi Par Adhunik Vimarsh: Kurushetra - Manjari, Jan-Jun 2007</li>
                  <li>Kalptaru Ki Utsav Lila Ke Sath Yatra Karate - Manjari, Jul-Dec 2007</li>
                  <li>Punarnava Ek Urdhaygami Abhisar Yatra - Akshar Academic Journal, 2011</li>
                  <li>Kedar Ki Kavita: Jamin Se Ek Sarthak - Akshar, 2014-2015</li>
                  <li>Apsanskrit Ki Shikar Bhasha - Manjari, 2008</li>
                  <li>Sagar Ke Jwar Me Maran Ka Tyohar - Manjari, 2011</li>
                  <li>Jainendra Ki Katha Bhasa - Padarpan, Sep 2015</li>
                  <li>Nepal Ki Yatra Samsmaran - Abhidesak, Jun-Aug 2023</li>
                  <li>Vande Matram - Bhartiye Smita Ki Katha - Rajasthan Parishad Nyaas, Smarika</li>
                  <li>Vishnukant Shastri Sahittik Evom Rajniti Vyaktitva - Muktanchal, Mar-Jun 2026</li>
                </ol>
              </div>
            </Tab>

            <Tab eventKey="awards" title="Awards & Memberships">
              <div className="pdesk-tab-content text-start">
                <Row>
                  <Col md={12}>
                    <h3 className="pdesk-section-title">Awards & Recognitions</h3>
                    <ol className="pdesk-list pdesk-award-list">
                      <li>District Topper of the Chhatra-Vritti Pariksha Uttar Pradesh at primary level.</li>
                      <li>Awarded the Gold Medal for standing first class in order of merit in M.A. Hindi.</li>
                      <li>Gold Medal in NCC. Awarded DG's Plaque of Honour for being all-rounder best cadet in September 2002.</li>
                      <li>Certificate of Merit for commandant group presentation and Cultural Programme. PRCN/GD/SW-69.</li>
                      <li>Post-Doctoral Research Award letter no. F.30-1/2009(SA-11) from UGC in July 2009.</li>
                      <li>Bharat Vidya Seromoni Award by International Institute of Education and Management in 2013.</li>
                      <li>Stood fifth in provisional merit panel for the post of Principal.</li>
                      <li>Munshi Prem Chand Sahitya Seva Samman-2022 by Bang Sahitik & Sanskritic adda.</li>
                      <li>Hindi Siksha Samman 2022 by Bhartiya Bhasa Parishad.</li>
                      <li>Principal of the Year Award by 9+1 skill India Edu leaders on 9/09/2025.</li>
                      <li>Rahul Samaritan Samman by Garifa Maitri Granthagar 24.04.2026.</li>
                      <li>Rahul Sankrityayn Samman 01.06.2026 by Vaishali International Vidyapith.</li>
                      <li>Commendations from: Hindi Sahitya Sammelan Prayag (2006), NCC Directorate Maharashtra (2007), Arya Samaj Bara Bazar, Kendrya Hindi Parishad (2009 & 2015), Purva Railway Sakha (2017).</li>
                    </ol>
                  </Col>

                  <Col md={12} className="mt-4">
                    <h3 className="pdesk-section-title">Membership of Professional Bodies</h3>
                    <ol className="pdesk-list">
                      <li>Ajivan Sadasya of Bangeeya Hindi Parishad Kolkata</li>
                      <li>Karyakari Adyakash of Bangiya Hindi Parishad (2016-2019)</li>
                      <li>Prantiya Adyakash of Narayani Hindi Sathitiya Academy, Bengal ekai</li>
                      <li>Mentor group of Vidyasagar Research Centre in Educating and society</li>
                      <li>Member of Hindi Mela</li>
                      <li>Treasurer of All Bengal Principal Council 2025</li>
                    </ol>
                  </Col>

                  <Col md={12} className="mt-4">
                    <h3 className="pdesk-section-title">Other Details</h3>
                    <ol className="pdesk-list">
                      <li>Resource person of the Refreshers course held by Gujrat University (2024) & Vadodara University (2026).</li>
                      <li>Members of Pear review committee of Muktanchal Patrika, ISSN-2350-10-65.</li>
                      <li>Chaired and acted as resource person in Several National and International Seminars/conferences of Hindi held in different parts of India.</li>
                      <li>Edited Manjari Samyik Patrika for 2007 to 2011.</li>
                      <li>Authored books used as syllabus books: Hindi Vyakran aur rachna (West Bengal Madhyamik) & Awadhi Lok Giton... (University of Calcutta 4yrs Syllabus).</li>
                      <li><strong>Key Institutional Contributions:</strong> Completed NAAC visit leading to accreditation enhancement (C+ to B, then B+), resolved space paucity by arranging second Campus area, improved infrastructure and ICT facilities, observed Amrit Mahautsav with a commemorative volume, and signed MOUs with agencies like MSTC for academic and employment opportunities.</li>
                    </ol>
                  </Col>
                </Row>
              </div>
            </Tab>
          </Tabs>
        </div>
      </Container>
    </div>
  );
};

export default AboutUs;
